import { normalizeLocale, SupportedLocale } from 'ClientPortal/src/i18n/supportedLocales'

export const ACTIVE_LOCALE_STORAGE_KEY = 'activeLocale'

export function readPersistedLocale(): SupportedLocale | undefined {
    try {
        const value = localStorage.getItem(ACTIVE_LOCALE_STORAGE_KEY)
        if (value === null || ['undefined', 'null'].includes(value)) {
            return undefined
        }

        return normalizeLocale(JSON.parse(value))
    } catch (error) {
        reportUnexpectedPersistenceError(error)
        return undefined
    }
}

export function writePersistedLocale(locale: SupportedLocale): void {
    try {
        localStorage.setItem(ACTIVE_LOCALE_STORAGE_KEY, JSON.stringify(locale))
    } catch (error) {
        if (isIgnorableStorageError(error)) {
            return
        }

        reportUnexpectedPersistenceError(error)
    }
}

function isIgnorableStorageError(error: unknown): boolean {
    return error instanceof DOMException && ['QuotaExceededError', 'NS_ERROR_DOM_QUOTA_REACHED', 'SecurityError'].includes(error.name)
}

function reportUnexpectedPersistenceError(error: unknown) {
    if (typeof globalThis.reportError === 'function') {
        globalThis.reportError(error)
    }
}
